import { STATUS } from "#candidate/constants"
import { useCandidateRedux } from "#candidate/redux/slice"
import PERMISOS from "#constants/perfiles"
import MainDetailsHeader from "#core/components/main-details/MainDetailsHeader"
import { UseHasPermission } from "#hooks/useHasPermission"
import { useReloadDetalle } from "#vacantes/redux/actions"
import EditIcon from "@mui/icons-material/Edit"
import PersonIcon from "@mui/icons-material/Person"
import PersonOffIcon from "@mui/icons-material/PersonOff"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { Button, Chip, Stack } from "@mui/material"
import { useNavigate } from "react-router-dom"
import CandidateStatusBoss from "../candidate-status/CandidateStatusBoss"
import CandidateStatusBossInterview from "../candidate-status/CandidateStatusBossInterview"
import CandidateStatusDisabled from "../candidate-status/CandidateStatusDisabled"
import CandidateStatusRhFilter from "../candidate-status/CandidateStatusRhFilter"
import CandidateDetailsEdit from "./CandidateDetailsEdit"
import CandidateDetailsHistory from "./CandidateDetailsHistory"
import CandidateStatusFinal from "../candidate-status/CandidateStatusFinal"
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation"
import CandidateActionMove from "../candidate-action/CandidateActionMove"
import CandidateStatusOnBoard from "../candidate-status/CandidateStatusOnBoard"
import CandidateStatusCollaborator from "../candidate-status/CandidateStatusCollaborator"
import { useVacanteRedux } from "#vacancy/redux/slice.js"
import { useColaboradorId } from "app/userSlice"


export default function CandidateDetailsHead() {
	const { candidate } = useCandidateRedux()
	const refresh = useReloadDetalle()
	const isRh = UseHasPermission(PERMISOS.RH)

	if (!candidate) return null

	const title = `# ${candidate.id} ${candidate.candidate_name} `
	let color = "success"

	const chips = (
		<Stack direction="row" spacing={1}>
			<Chip label={candidate.status_name} color={color} size={"medium"} />
			<Chip
				label={candidate.is_enabled ? "Habilitado" : "Deshabilitado"}
				color={candidate.is_enabled ? "success" : "error"}
				size={"medium"}
			/>
		</Stack>
	)
	const is_enabled = candidate.is_enabled
	const is_edit = is_enabled && candidate.vacancy_active

	const buttons = [
		{
			title: "Historial",
			icon: ScheduleIcon,
			component: CandidateDetailsHistory,
		},

		{
			title: "cambiar vacante",
			icon: TransferWithinAStationIcon,
			hidden: !isRh || !is_enabled,
			component: CandidateActionMove,
		},

		{
			title: "Editar",
			icon: EditIcon,
			hidden: !isRh || !is_edit,
			component: CandidateDetailsEdit,
		},
		{
			title: is_enabled ? "Deshabilitado Candidato" : "Habilitado Candidato",
			icon: is_enabled ? PersonOffIcon : PersonIcon,
			hidden: !isRh || candidate.status === STATUS.COLLABORATOR,
			color: is_enabled ? "error" : "success",
			component: CandidateStatusDisabled,
		},
	]
	return (
		<MainDetailsHeader
			{...{ title, buttons }}
			data={candidate}
			refresh={refresh}
			chips={chips}
			action={
				is_enabled ? (
					<>
						<ButtonsStatus />
						{isRh && <ButtonsStatusFinal />}
					</>
				) : null
			}
			noUsePaper
		/>
	)
}
const ButtonsStatus = () => {
	const isRh = UseHasPermission(PERMISOS.RH)
	const navigate = useNavigate()
	const { candidate } = useCandidateRedux()
	const { vacancy } = useVacanteRedux()
	const colaborador = useColaboradorId()
	const is_edit = candidate.is_enabled && candidate.vacancy_active
	if (!is_edit) return null

	switch (candidate.status) {
		case STATUS.RH_FILTERS:
			return <CandidateStatusRhFilter />

		case STATUS.SCHEDULED_BY_HR:
			if (!isRh) return null
			return (
				<Button
					onClick={() => {
						navigate(`evaluation`)
					}}
				>
					Realizar Entrevista RH
				</Button>
			)
		case STATUS.HR_INTERVIEW:
			return <CandidateStatusBoss is_boss={true} />

		case STATUS.SCHEDULED_BY_BOSS:
			return (
				<Button
					onClick={() => {
						navigate(`evaluation`)
					}}
				>
					Realizar Entrevista Jefe
				</Button>
			)
		case STATUS.BOSS_INTERVIEW:
			if (!isRh && vacancy.created_by !== colaborador) return null
			return <CandidateStatusBossInterview />

		default:
			return null
	}
}
const ButtonsStatusFinal = () => {
	const { candidate } = useCandidateRedux()
	const is_edit = candidate.is_enabled && candidate.vacancy_active
	if (!is_edit) return null

	if (!candidate.is_selected) return null
	switch (candidate.status) {
		case STATUS.FINAL_CANDIDATE:
			return <CandidateStatusFinal />
		case STATUS.OFFER:
			return <CandidateStatusOnBoard />
		case STATUS.ONBOARD:
			return <CandidateStatusCollaborator />
		default:
			return null
	}
}
